export const accMarketSelectorSupport = function (formElement) {
  const self = this

  self.loadedStates = {}

  self.getStateData = async function (state) {
    if (!state) {
      // used if user selected "select a state"
      return []
    }
    let stateData = self.loadedStates[state] || null

    if (!stateData) {
      await self.getStateDataFromApi(state)
        .then(
          fetchedStateData => {
            stateData = fetchedStateData
            self.loadedStates[state] = stateData
          }
        )
    }
    return stateData
  }

  self.getStateDataFromApi = async function (state) {
    return await fetch(`${sharedApiUrl}/acc/v1/get-state.php?state=${state}`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(response => response.data || [])
      .catch((error) => {
        console.error('Error:', error)
      })
  }

  self.handleStateChange = function (e) {
    self.getStateData(e.target.value)
      .then(stateData => {
        self.fillCitySelector(stateData)
      })
  }

  self.handleCityChange = function (e) {
    // fill hidden market input
    const market = self.citySelectorElement.options[self.citySelectorElement.selectedIndex].getAttribute('market')
    self.marketInputElement.value = market
  }

  // clear all option except for the default "Please select..."
  self.clearOptions = function (selectElement) {
    selectElement.querySelectorAll('option')
      .forEach(option => {
        if (option.value !== '') {
          option.remove()
        }
      })
  }

  self.fillCitySelector = function (stateData) {
    self.clearOptions(self.citySelectorElement)
    self.marketInputElement.value = ''

    stateData.cities.forEach(row => {
      const option = new Option(row.city, row.market_value)
      option.setAttribute('market', row.market)
      option.setAttribute('is_market_active', row.active)
      option.setAttribute('is_web_active', row.web_pt_active)
      option.setAttribute('is_cyb_active', row.cyb_pt_active)
      self.citySelectorElement.appendChild(option)
    })
  }

  self.stateSelectorElement = formElement.querySelector("[fieldType='accStateSelector']")
  self.citySelectorElement = formElement.querySelector("[fieldType='accCitySelector']")
  self.marketInputElement = formElement.querySelector("[name='market_name']")

  if (self.stateSelectorElement && self.citySelectorElement && self.marketInputElement) {
    self.stateSelectorElement.addEventListener('change', self.handleStateChange)
    self.citySelectorElement.addEventListener('change', self.handleCityChange)
  } else {
    console.log("Error: ACC state selector, city selector or market hidden input is missing.")
  }
}